// extracted by mini-css-extract-plugin
module.exports =  {"avatar":"tnt6Y961HQ3slAFXoUWC","avatarBackground":"Q_7NjAaJFoGXR2FoGrul","avatarChar":"lrjeTVv7bS_kjsIKfel_"};